package org.solyton.solawi.bid.module.shares.component.modal

import androidx.compose.runtime.Composable
import org.evoleq.compose.Markup
import org.evoleq.compose.modal.Modal
import org.evoleq.compose.modal.ModalData
import org.evoleq.compose.modal.ModalType
import org.evoleq.compose.modal.Modals
import org.evoleq.compose.style.data.device.DeviceType
import org.evoleq.device.data.mediaType
import org.evoleq.language.Lang
import org.evoleq.math.Source
import org.evoleq.math.emit
import org.evoleq.optics.storage.Storage
import org.evoleq.optics.storage.nextId
import org.evoleq.optics.storage.put
import org.evoleq.optics.transform.times
import org.jetbrains.compose.web.dom.ElementScope
import org.solyton.solawi.bid.module.banking.component.form.sepa.PartialSepaCollection
import org.solyton.solawi.bid.module.banking.component.form.sepa.UpsertSepaCollectionForm
import org.solyton.solawi.bid.module.banking.component.form.sepa.defaultSepaCollectionInputs
import org.solyton.solawi.bid.module.banking.data.application.BankingApplication
import org.solyton.solawi.bid.module.banking.data.application.deviceData
import org.solyton.solawi.bid.module.banking.data.bankaccount.BankAccount
import org.solyton.solawi.bid.module.style.modal.commonModalStyles
import org.solyton.solawi.bid.module.style.wrap.Wrap
import org.w3c.dom.HTMLElement


@Markup
@Suppress("FunctionName")
fun AttachSepaCollectionModal(
    id: Int,
    texts: Lang.Block,
    modals: Storage<Modals<Int>>,
    storage: Storage<BankingApplication>,
    device: Source<DeviceType>,
    bankAccounts: Source<List<BankAccount>>,
    sepaCollection: PartialSepaCollection?,
    setSepaCollection: (PartialSepaCollection) -> Unit,
    isOkButtonDisabled: () -> Boolean,
    update: ()->Unit
): @Composable ElementScope<HTMLElement>.()->Unit = Modal(
    type = ModalType.Dialog,
    id = id,
    modals = modals,
    device = storage * deviceData * mediaType.get,
    onOk = {
        update()
    },
    onCancel = {},
    texts = texts,
    styles = commonModalStyles(device),
    isOkButtonDisabled = isOkButtonDisabled
) {
    Wrap {
        UpsertSepaCollectionForm(
            inputs = Source{defaultSepaCollectionInputs()} ,
            bankAccounts =  bankAccounts.emit(),
            sepaCollection = sepaCollection,
            setSepaCollection = setSepaCollection
        )
    }
}

@Markup
fun Storage<Modals<Int>>.showAttachSepaCollectionModal(
    storage: Storage<BankingApplication>,
    texts: Lang.Block,
    device: Source<DeviceType>,
    bankAccounts: Source<List<BankAccount>>,
    sepaCollection: PartialSepaCollection?,
    setSepaCollection: (PartialSepaCollection) -> Unit,
    isOkButtonDisabled: () -> Boolean,
    update: ()->Unit
) = with(nextId()) {
    put(this to ModalData(this,
        ModalType.Dialog,
        AttachSepaCollectionModal(
            this,
            texts,
            this@showAttachSepaCollectionModal,
            storage,
            device,
            bankAccounts,
            sepaCollection,
            setSepaCollection,
            isOkButtonDisabled,
            update = update
        )
    ) )
}
